import React, { useState } from 'react';
import { Table } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import styled from 'styled-components';
import { ProctorFolder } from '../../../../assets/images/svgs';
import { CredusWrapper } from 'ui';
import ProctoringModal from '../modals/ProctoringModal';
import { CandidateTestDetails, ProctoringTableProps } from '../../report-models/report.interface';
import { formatDateTime } from '../../../../utils/helpers';



const ProctoringTable: React.FC<ProctoringTableProps> = (data) => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const [candidateId, setCandidateId] = useState<number>(0);
  const [testId, setTestId] = useState<number>(0);

  const onOpenModal = (item: CandidateTestDetails) => {
    setCandidateId(item.candidateId);
    setTestId(item.testId);
    setShowModal(true);
  };

  const columns: ColumnsType<CandidateTestDetails> = [
    {
      title: 'File Name',
      dataIndex: 'candidate',
      key: 'candidate', 
      render: (text) => {
        return (
          <CredusWrapper align="center" display="flex" gap="1.87rem">
            {' '}
            <ProctorFolder /> {data.fileStats[1]?.fileName}
          </CredusWrapper>
        );
      },
    },
    {
      title: 'File Items',
      dataIndex: 'age',
      key: 'age',
      render: () => {
        return (
          <CredusWrapper align="center" display="flex" gap="1.87rem">
            {' '}
            <ProctorFolder /> {data.fileStats[1]?.itemCount}
          </CredusWrapper>
        );
      },
    },
    {
      title: 'Last uploaded',
      dataIndex: 'address',
      key: 'address',
      render: () => {
        return (
          <CredusWrapper align="center" display="flex" gap="1.87rem">
            {' '}
            <ProctorFolder />{' '}
            {data.fileStats[1]?.lastUpdated && formatDateTime(
              data.fileStats[1]?.lastUpdated
            )}
          </CredusWrapper>
        );
      },
    },
    {
      title: 'File size',
      dataIndex: 'address',
      key: 'address',
      render: () => {
        return (
          <CredusWrapper align="center" display="flex" gap="1.87rem">
            {' '}
            <ProctorFolder /> {data.fileStats[1]?.sizeMb}mb
          </CredusWrapper>
        );
      },
    },
    {
      title: 'Action',
      key: 'action',
      render: (record) => (
        <CredusWrapper display="flex" gap="4px">
          <ActionWrapper open onClick={() => onOpenModal(record)}>
            Open
          </ActionWrapper>
          <ActionWrapper open={false}>Delete</ActionWrapper>
        </CredusWrapper>
      ),
    },
  ];

  return (
    <TableWrap>
      {showModal && (
        <ProctoringModal
          onSetModal={setShowModal}
          open={showModal}
          candidateId={candidateId}
          testId={testId}
        />
      )}
      <Table columns={columns} dataSource={data.data} />
    </TableWrap>
  );
};

export default ProctoringTable;

const TableWrap = styled.div`
  .ant-table-thead .ant-table-cell {
    background: #ffeae7 !important;
  }
`;

const ActionWrapper = styled.div<{ open?: boolean }>`
  padding: 0.3rem 0.8rem;
  font-size: 12px;
  font-weight: 600px;
  border-radius: 30px;
  cursor: pointer;
  color: ${({ open }) => (open ? '#000000': '#FC391D')};
  background: ${({ open }) => (open ? '#F5F6F8' : '#FFF1EF')};
`;
